import React, { useState, useEffect, useContext } from "react";
import { MonthlyApi } from "../../../../../../api/Api";
import {PASS_KEY,WEB_KEY,BaseUrl} from '../../../../../../api/AxiosApi'
import { jsPDF } from "jspdf";
import "jspdf-autotable"; // Ensure autoTable is included
import * as XLSX from "xlsx";

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import logo from '../../../../../../assets/img/logos/logo 2.png';
import { AuthenticationContext } from "../../../../../../context/AuthenticationContext";
import ExportExcel from "../../../../../../components/exportExcel/ExportExcel1";
import ExportPdf from "../../../../../../components/exportPdf/ExportPdf";

export default function LogTab() {
    const { LoggedInUserInfo } = useContext(AuthenticationContext)
    const getCurrentMonth = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        return `${year}-${month}`;
    };
    
    // Function to get date six months ago
    const getSixMonthsAgo = () => {
        const now = new Date();
        now.setMonth(now.getMonth() - 5); // Subtract 6 months
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        return `${year}-${month}`;
    };
    
    const [startDate, setStartDate] = useState(getSixMonthsAgo()); // 5 months ago
    const [endDate, setEndDate] = useState(getCurrentMonth()); // Current month

    const [logData, setLogData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(10); // You can adjust this number as needed
    const [totalPages, setTotalPages] = useState(1);

    const credentials = {
        LOGIN_ID: localStorage.getItem("LoginID") || "",
        PASS_KEY: localStorage.getItem("KEY") || "xyz",
        LCODE: localStorage.getItem("LCODE") || "",
        MT1: startDate,
        MT2: endDate,
        TYP: "A",
        WEB_KEY: "WEBXYZ321",
        FID: "216HT001",
    };

    const fetchLogData = async () => {
        setLoading(true);
        setError(null);
        setLogData([]);

        try {
            const res = await MonthlyApi(credentials);
            if (res?.MONTH && Array.isArray(res?.MONTH)) {
                setLogData(res?.MONTH);
                setTotalPages(Math.ceil(res?.MONTH.length / rowsPerPage)); // Calculate total pages
            } else {
                // console.error("Invalid data structure:", res);
                setLogData([]);
            }
        } catch (err) {
            // console.error("Error fetching data:", err);
            setError("Failed to fetch data. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLogData();
    }, [startDate, endDate]);

     const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${credentials.LOGIN_ID}&LOC_CODE=${credentials.LCODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`

    const tableHeaders = logData.length > 0 ? Object.keys(logData[0]) : [];

    // Pagination: Slice data based on the current page
    const paginatedData = logData.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    // Pagination controls
    const goToPage = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    // Export to Excel function
    // const exportToExcel = () => {
    //     const ws = XLSX.utils.json_to_sheet(logData); // Convert JSON data to Excel sheet
    //     const wb = XLSX.utils.book_new(); // Create a new Excel workbook
    //     XLSX.utils.book_append_sheet(wb, ws, "Log Data"); // Append sheet to workbook
        
    //      XLSX.writeFile(wb, `Monthly Energy Log  ${LoggedInUserInfo?.username} From ${credentials.MT1 || ""} To ${credentials.MT2 || ""} .xlsx`);
    // };

    // const exportToExcel = async () => {
    //         const workbook = new ExcelJS.Workbook();
    //         const worksheet = workbook.addWorksheet("Monthly Energy Report");
    
    //         try {
    //             // ===== Load uploaded image (static file instead of API) =====
    //             const response = await fetch(ImageUrl);
    //             const blob = await response.blob();
    //             const base64Logo = await new Promise((resolve, reject) => {
    //                 const reader = new FileReader();
    //                 reader.readAsDataURL(blob);
    //                 reader.onloadend = () => resolve(reader.result);
    //                 reader.onerror = reject;
    //             });
    
    //             // ===== Add image to Excel =====
    //             const logo = workbook.addImage({
    //                 base64: base64Logo,
    //                 extension: "png",
    //             });
    
    //             // Place logo on top-left
    //             worksheet.mergeCells("A1:D4"); // Logo space
    //             worksheet.addImage(logo, {
    //                 tl: { col: 0, row: 0 }, // top-left corner
    //                 ext: { width: 250, height: 65 }, // adjust size
    //             });
    
    //             // ===== Company Name & Address (Dynamic) =====
    //             const companyName = LoggedInUserInfo?.username || "";
    //             const companyAddress = LoggedInUserInfo?.Address || "";
    
    //             // Company Name row
    //             worksheet.mergeCells("F1:P2");
    //             worksheet.getCell("F1").value = `Plant Name/User Name: ${companyName}`;
    //             worksheet.getCell("F1").font = { size: 14, bold: true };
    //             worksheet.getCell("F1").alignment = { vertical: "middle", horizontal: "left" };
    
    //             // Address row
    //             worksheet.mergeCells("F3:P4");
    //             worksheet.getCell("F3").value = `Plant Address: ${companyAddress}`;
    //             worksheet.getCell("F3").font = { size: 11, color: { argb: "555555" } };
    //             worksheet.getCell("F3").alignment = { vertical: "middle", horizontal: "left" };
    
    
    //         } catch (error) {
    //             console.error("Logo fetch/convert error:", error);
    //         }
    
    //         // ===== Table Header =====
    //         worksheet.addRow([]);
    //         worksheet.addRow(Object.keys(logData[0] || {}));
    //         logData.forEach((item) => {
    //             worksheet.addRow(Object.values(item));
    //         });
    
    //         // ===== Export file =====
    //         const buffer = await workbook.xlsx.writeBuffer();
    //         saveAs(
    //             new Blob([buffer]),
    //             `Monthly Energy Log  ${LoggedInUserInfo?.username} From ${credentials.MT1 || ""} To ${credentials.MT2 || ""} .xlsx`
    //         );
    //     };
    

    const exportToExcel = async () => {
        await ExportExcel(
            ImageUrl,
            logData,
            startDate,
            endDate,
            "Monthly Energy Log",
            LoggedInUserInfo
        );
    };
    
    // const exportToPDF = () => {
    //     const doc = new jsPDF({ orientation: 'landscape', format: [300, 700] });
      
    //     const pageWidth = doc.internal.pageSize.width;
    //     const textX = 10;   // Left margin
    //     const textY = 10;   // Top margin
      
    //     // ==== LEFT SIDE (Company Info) ====
    //     doc.setFontSize(15);
    //     doc.text(`Plant Name/User Name: ${LoggedInUserInfo?.username || ""}`, textX, textY + 10);
      
    //     doc.setFontSize(10);
    //     doc.text(`Plant Capacity: ${LoggedInUserInfo?.PLANT_CAPACITY || ""}`, textX, textY + 16);
    //     doc.text(`Plant Address: ${LoggedInUserInfo?.Address || ""}`, textX, textY + 22);
      
    //     // ==== CENTER (Main Logo) ====
    //     if (logo) {
    //       const imgWidth = 30;
    //       const imgHeight = 20;
    //       const xCenter = (pageWidth - imgWidth) / 2;
    //       doc.addImage(logo, "PNG", xCenter, 10, imgWidth, imgHeight);
    //     }
      
    //     // ==== RIGHT SIDE (Another Logo / ISO mark) ====
    //     if (ImageUrl) {
    //       const rightImgWidth = 100;
    //       const rightImgHeight = 25;
    //       const xRight = pageWidth - rightImgWidth - 10;
    //       doc.addImage(ImageUrl, "PNG", xRight, 12, rightImgWidth, rightImgHeight);
    //     }
      
    //     // ==== TITLE (Below Header) ====
    //     const title = `Monthly Energy Log From ${credentials.MT1 || ""} To ${credentials.MT2 || ""}`;
    //     doc.setFontSize(12);
    //     doc.text(title, pageWidth / 2, 40, { align: "center" });
      
    //     // ==== EXTRACT TABLE DATA ====
    //     const table = document.getElementById("log-table");
    //     const rows = Array.from(table.rows);
      
    //     const headers = Array.from(rows[0].cells).map(cell => cell.innerText.trim());
    //     const body = rows.slice(1).map(row =>
    //       Array.from(row.cells).map(cell => cell.innerText.trim())
    //     );
      
    //     // ==== TABLE START ====
    //     let startY = 50;
    //     doc.autoTable({
    //       head: [headers],
    //       body: body,
    //       startY: startY,
    //       theme: "grid",
    //       styles: {
    //         fontSize: 10,
    //         halign: "center",
    //         cellPadding: 3
    //       },
    //       headStyles: {
    //         fillColor: [41, 128, 185], // nice blue header
    //         textColor: [255, 255, 255]
    //       }
    //     });
      
    //     // ==== SAVE FILE ====
    //     doc.save(`Monthly Energy Log From ${credentials.MT1 || ""} To ${credentials.MT2 || ""} .pdf`);
        
    //   };
      

    const exportToPDF = async () => {
        await ExportPdf(
            ImageUrl,
            paginatedData,
            startDate,
            endDate,
            "Monthly Energy Log",
            LoggedInUserInfo,
            logo,
            tableHeaders

        );
    };

    

    return (
        <div style={{ padding: "10px", fontFamily: "Arial, sans-serif" }}>
            {/* Top Section */}
            <div className="row">
                <div className="col-md-12">
            <div style={containerStyle}>
                <p style={responsiveHeaderStyle}>Monthly Energy Log</p>
                <div style={responsiveControlsStyle}>
                    <label>
                        {/* From Date: */}
                        <input
                            type="month"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            style={inputStyle}
                        />
                    </label>
                    <label>
                        {/* To Date: */}
                        To
                        <input
                            type="month"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            style={inputStyle}
                        />
                    </label>
                    <button onClick={fetchLogData} style={buttonStyle}>Show</button>
                    <button onClick={exportToExcel} style={exportButtonStyle}>Excel</button>
                    <button onClick={exportToPDF} style={exportButtonStyle2}>PDF</button>
                </div>
            </div>
            </div>
            </div>
            {/* Table Section */}
            <div className="table-responsive">
                <table id="log-table" className="table table-bordered table-striped table-hover">
                    <thead style={{ backgroundColor: "rgb(253, 248, 228)" }}>
                        <tr>
                            {tableHeaders.map((header, index) => (
                                <th
                                    key={index}
                                    className="text-center align-middle"
                                    style={{
                                        color: "rgb(53, 110, 53)",
                                        padding: "12px 10px",
                                        whiteSpace: "nowrap",
                                        minWidth: "100px",
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {header.replace(/_/g, " ")}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td
                                    colSpan={tableHeaders.length}
                                    className="text-center"
                                    style={{ padding: "15px", fontSize: "12px", color: "gray" }}
                                >
                                    Loading...
                                </td>
                            </tr>
                        ) : paginatedData.length > 0 ? (
                            paginatedData.map((item, rowIndex) => (
                                <tr key={rowIndex} className="table-row-hover">
                                    {tableHeaders.map((key, colIndex) => (
                                        <td
                                            key={colIndex}
                                            className="text-center align-middle"
                                            style={{
                                                padding: "10px",
                                                whiteSpace: "nowrap",
                                                minWidth: "100px",
                                                
                                                verticalAlign: "middle",
                                            }}
                                        >
                                            {item[key] !== null && item[key] !== undefined ? item[key] : ""}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td
                                    colSpan={tableHeaders.length}
                                    className="text-center"
                                    style={{ padding: "15px", fontSize: "16px", color: "gray" }}
                                >
                                    No data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>



            {/* Pagination Controls */}
            <div style={{ textAlign: "right", marginTop: "20px" }}>
                <button onClick={() => goToPage(currentPage - 1)} style={paginationButtonStyle}>
                    Prev
                </button>
                <span style={{ margin: "0 10px" }}>
                    Page {currentPage} of {totalPages}
                </span>
                <button onClick={() => goToPage(currentPage + 1)} style={paginationButtonStyle}>
                    Next
                </button>
            </div>

            {/* Error Message */}
            {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}
        </div>
    );
}

/* Styles */
const containerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    marginBottom: "7px",
    border: "1px solid lightgray",
    padding: "3px",
    borderRadius: "7px"
};

const responsiveHeaderStyle = {
    fontWeight: "bold",
    margin: "0",
};

const responsiveControlsStyle = {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    justifyContent: "center",
};

const inputStyle = {
    padding: "3px 6px",
    borderRadius: "14px",
    border: "1px solid #ccc",
    marginLeft: "5px",
    fontSize: "10px",
};

const buttonStyle = {
    backgroundColor: "#007BFF",
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    padding: "2px 9px",
    cursor: "pointer",
    fontSize: "10px",
};

const exportButtonStyle = {
    backgroundColor: "darkblue",
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    padding: "3px 9px",
    cursor: "pointer",
    fontSize: "11px",
};

const exportButtonStyle2 = {
    backgroundColor: "#f44336",
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    padding: "3px 9px",
    cursor: "pointer",
    fontSize: "11px",
};




const paginationButtonStyle = {
    backgroundColor: "white",
    color: "#356E35",
    border: "1px solid #ddd",
    borderRadius: "7px",
    padding: "6px 12px",
    cursor: "pointer",
    fontSize: "14px",
    margin: "0 5px",
};
